import type {
  BillingSummary,
  WalletEntryView,
  CheckoutContext,
  CheckoutSessionResponse,
  BillingPortalResponse,
  PaymentMethodView,
  InvoiceView,
  AccountUsageSummary,
  ProvenanceSpendSummary,
  AutoTopupUpdateInput,
  AutoTopupUpdateResult,
  PlanOffer,
  EntitlementView,
} from '@vivport/backend/types';
import { httpClient } from './http-client';

export interface BillingSummaryResponse {
  summary: BillingSummary;
  entries: WalletEntryView[];
}

export interface PaymentMethodResponse {
  paymentMethod: PaymentMethodView | null;
}

export interface InvoicesResponse {
  invoices: InvoiceView[];
}

export const getBillingSummary = () =>
  httpClient.get<BillingSummaryResponse>('/protected/billing/summary');

export const startSubscriptionCheckout = (context?: CheckoutContext) =>
  httpClient.post<CheckoutSessionResponse, { context?: CheckoutContext }>(
    '/protected/billing/subscription/checkout',
    { context }
  );

export const startTopup = (amountAud: number, context?: CheckoutContext) =>
  httpClient.post<CheckoutSessionResponse, { amountAud: number; context?: CheckoutContext }>(
    '/protected/billing/topup/checkout',
    { amountAud, context }
  );

export const getPlanOffer = () => httpClient.get<PlanOffer>('/protected/billing/plan-offer');

export const getEntitlement = () =>
  httpClient.get<EntitlementView>('/protected/billing/entitlement');

export const confirmSubscription = () =>
  httpClient.post<EntitlementView>('/protected/billing/subscription/confirm');

export const openBillingPortal = () =>
  httpClient.post<BillingPortalResponse>('/protected/billing/portal');

export const getPaymentMethod = () =>
  httpClient.get<PaymentMethodResponse>('/protected/billing/payment-method');

export const getInvoices = () => httpClient.get<InvoicesResponse>('/protected/billing/invoices');

export const getUsage = (params?: { from?: string; to?: string }) => {
  const qs = new URLSearchParams();
  if (params?.from) qs.set('from', params.from);
  if (params?.to) qs.set('to', params.to);
  const q = qs.toString();
  return httpClient.get<AccountUsageSummary>(`/protected/billing/usage${q ? `?${q}` : ''}`);
};

export const setAutoTopup = (input: AutoTopupUpdateInput) =>
  httpClient.post<AutoTopupUpdateResult, AutoTopupUpdateInput>('/protected/billing/auto-topup', input);

export const getChatSpend = (contentId: number) =>
  httpClient.get<ProvenanceSpendSummary>(`/protected/billing/spend/${contentId}`);
